import { UtpCardStructure } from 'common/components';
import { KITCHEN_CDN_PATH } from '../../old-kitchen-constants';
import { FreeKitchenProjectModal } from './components/free-kitchen-project-modal';
import { ServicesModal } from './components/services-modal';
import { GuaranteeModal } from './components/guarantee-modal';
import { AllPurchasesModal } from './components/all-purchases-modal';

export const KITCHEN_DESIGN_CARD_LIST: UtpCardStructure<{ regionId: string }>[] = [
  {
    elementName: 'Бесплатный проект кухни',
    header: {
      title: 'Бесплатный проект кухни',
    },
    description: {
      text: 'Специалист создаст проект в\u00A0магазине или онлайн',
      mobileText: 'Со\u00A0специалистом в\u00A0магазине или\u00A0онлайн',
    },
    image: {
      alt: 'Бесплатный проект кухни',
      src: `${KITCHEN_CDN_PATH}/utp/project.png/project-01.png`,
    },
    modal: { content: FreeKitchenProjectModal },
  },
  {
    elementName: 'Услуги Лемана ПРО',
    header: {
      title: 'Услуги Лемана\u00A0ПРО',
    },
    description: {
      text: 'Все работы под ключ\u00A0\u2014 от\u00A0замера до\u00A0установки',
    },
    image: {
      alt: 'Услуги Лемана ПРО',
      src: `${KITCHEN_CDN_PATH}/utp/services.png/services-01.png`,
    },
    modal: { content: ServicesModal },
  },
  {
    elementName: 'Гарантия и возврат',
    header: {
      title: 'Гарантия и\u00A0возврат',
    },
    description: {
      text: 'Гарантия 25\u00A0лет и\u00A0100 дней на\u00A0возврат',
    },
    image: {
      alt: 'Гарантия и возврат',
      src: `${KITCHEN_CDN_PATH}/utp/guarantee.png/guarantee-01.png`,
    },
    modal: { content: GuaranteeModal },
  },
  {
    elementName: 'Все покупки в Лемана ПРО',
    header: {
      title: 'Все покупки в\u00A0Лемана\u00A0ПРО',
    },
    description: {
      text: 'Все товары отдела кухни',
    },
    image: {
      alt: 'Товары отдела кухни',
      src: `${KITCHEN_CDN_PATH}/utp/all-purchases.png/all-purchases-01.png`,
    },
    modal: {
      content: AllPurchasesModal,
      size: 'm',
    },
  },
];
